import React from 'react';

// import Header from '../../../Components/Header';
import Header from '../../../components/Header';
import ShiftLogBooks from './ShiftLogBook';
const ShiftLogBook = () => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Shift Logbook'} />
      <div className="flex-1 overflow-auto">
        <ShiftLogBooks />
      </div>
    </div>
  );
};

export default ShiftLogBook;
